import { Injectable } from '@angular/core';
import {
  ConfirmDialogComponent,
  ConfirmDialogData,
} from '../components/dialogs/confirm-dialog/confirm-dialog.component';
import {
  AlertDialogComponent,
  AlertDialogData,
} from '../components/dialogs/alert-dialog/alert-dialog.component';
import { ComponentType } from '@angular/cdk/portal';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root',
})
export class ViewService {
  constructor(private dialog: MatDialog) {}

  showConfirm(data: ConfirmDialogData, config?: Omit<Partial<MatDialogConfig>, 'data'>) {
    return this.dialog.open<ConfirmDialogComponent, ConfirmDialogData>(ConfirmDialogComponent, {
      panelClass: 'modal-container',
      backdropClass: 'modal-background',
      data,
      ...config,
    });
  }

  showAlert(data: AlertDialogData, config?: Omit<Partial<MatDialogConfig>, 'data'>) {
    return this.dialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
      panelClass: 'modal-container',
      backdropClass: 'modal-background',
      data,
      ...config,
    });
  }

  showDialog<T, D = any, R = any>(
    component: ComponentType<T>,
    config?: MatDialogConfig<D>,
  ): MatDialogRef<T, R> {
    return this.dialog.open(component, config);
  }

  closeAllDialogs() {
    this.dialog.closeAll();
  }
}
